import { combineReducers } from 'redux';
import active from '../screens/Active/reducers';
import end from '../screens/End/reducers';
import index from '../screens/Index/reducers';
import store from '../screens/Store/reducers';
export default combineReducers({
  active,
  end,
  index,
  store,
});



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/Orders/reducers/index.js
 **/